var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('footer',{staticClass:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }